import { useAuthContext } from "./hooks/useAuthContext"
import { Layout } from "antd"
import "./App.css"

//Components
import { Sidebar } from "./components/Sidebar/Sidebar"
import { AdminTopBar } from "./components/TopBar/AdminTopBar"
import { TopBar } from "./components/TopBar/TopBar"

// Router
import Router from "./Router"
import { loadingSpin } from "./components/Elements/LoadingSpinner"
import { useEffect } from "react"
import useFetchWarehouseOrders from "./hooks/useFetchWarehouseOrders"
import useAppUpdateCheck from "./hooks/useAppUpdateCheck"
import { FilterProvider } from "./context/FilterContext"
import useFetchUserBasedData from "./hooks/useFetchUserBasedData"
import useAdminModeStore from "./store/Admin/adminMode"
import AppLoginOverlay from "./components/utils/AppLoginOverlay"
import useViewModeStore from "./store/viewMode/useViewModeStore"
import ViewModeBanner from "./components/Admin/ViewMode/ViewModeBanner"

const { Content } = Layout

const useGlobalErrorHandler = () => {
  useEffect(() => {
    const errorHandler = (event) => {
      if (event.message.includes("ResizeObserver loop completed with undelivered notifications")) {
        console.log(event.message)
        event.preventDefault() // Prevents the error from being logged to the console
      }
    }
    window.addEventListener("error", errorHandler)
    return () => {
      window.removeEventListener("error", errorHandler)
    }
  }, [])
}

function App() {
  const { user, authIsReady, semiAdmin, firestoreData } = useAuthContext()
  const { adminMode } = useAdminModeStore()
  const { isViewMode } = useViewModeStore()

  useFetchUserBasedData()
  //fetches all the notifications
  const { loading } = useFetchWarehouseOrders()
  const isUpdateAvailable = useAppUpdateCheck()

  useEffect(() => {
    if (isUpdateAvailable) {
      console.log("update avaiable")
    }
  }, [isUpdateAvailable])

  //removes the loop resize error
  useEffect(() => {
    window.addEventListener("error", (e) => {
      if (e.message === "ResizeObserver loop limit exceeded") {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client-overlay-div",
        )
        const resizeObserverErr = document.getElementById("webpack-dev-server-client-overlay")
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none")
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none")
        }
      }
    })
  }, [])

  useGlobalErrorHandler()

  //returns a loading if no auth returned
  if (!authIsReady && loading) {
    return loadingSpin(50)
  }

  // Check if user exists and doesn't have app login permission
  if (user && firestoreData && !firestoreData.hasAppLogin) {
    return <AppLoginOverlay />
  }

  return (
    <div className="App">
      <ViewModeBanner />
      {authIsReady && (
        <>
          <FilterProvider>
            <Layout className="site-layout" style={isViewMode ? { marginTop: 40 } : undefined}>
              {user && <Sidebar />}
              <Layout className="layout-app">
                {user && (adminMode || semiAdmin ? <AdminTopBar /> : <TopBar />)}
                <Content className="content-app">
                  <Router />
                </Content>
              </Layout>
            </Layout>
          </FilterProvider>
        </>
      )}
    </div>
  )
}

export default App
